import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { GET_REPO_FILE_HISTORY } from "./gql";

type UseGetRepoFileHistoryProps = {
  repoId: string;
  filePath: string;
  skip?: boolean;
};

const useGetRepoFileHistory = ({ repoId, filePath, skip }: UseGetRepoFileHistoryProps) => {
  // The backend returns the current version as the first item in the list and the previous version as the second.
  // Further, we could also implement full file history viewing or "blame" functionality.
  const { data, loading, error, previousData } = useQuery(GET_REPO_FILE_HISTORY, {
    variables: { repoID: repoId, filePath, first: 2, after: null },
    skip,
  });

  const { currentFileVersion, previousFileVersion } = useMemo(() => {
    const edges = (data?.repoFileHistory ?? previousData?.repoFileHistory)?.edges;

    return {
      currentFileVersion: edges?.[0]?.node,
      previousFileVersion: edges?.[1]?.node,
    };
  }, [data, previousData]);

  return {
    currentFileVersion,
    previousFileVersion,
    loading,
    error,
  };
};

export default useGetRepoFileHistory;
